import { memo, useMemo } from 'react'
import { PersonalizationModalOpenButton } from '@vp/design-personalization-widget'
import { Column, GridContainer, Row } from '@vp/swan'
import { useInView } from 'react-intersection-observer'
import { StickyHeader } from '~/app/features/Gallery/components/Header/ActionHeader/components/StickyHeader'
import { StaticHeader } from '~/app/features/Gallery/components/Header/ActionHeader/components/StaticHeader'
import { galleryHeaderId } from '~/app/features/Gallery/components/Header/ActionHeader/constants'

import { SIDEBAR_GRID_SPANS, MAIN_GRID_SPANS } from '~/app/features/Gallery/constants'
import { FilterMenu } from '~/app/features/Gallery/components/Header/ActionHeader/components/FilterMenu'
import { SearchBox } from '~/app/features/Gallery/components/Header/ActionHeader/components/Searchbox'
import { FavoritesCTA } from '~/app/features/Gallery/components/Header/ActionHeader/components/Favorites'
import { useShowFavorites } from '~/app/features/Gallery/hooks/useShowFavorites'
import { usePersonalizationConfig } from '~/app/features/Gallery/hooks/usePersonalizationConfig'

export const ActionHeader = memo(() => {
  const { ref: headerRef, inView, entry } = useInView()
  const headerIsVisible = useMemo(() => inView || !entry, [inView, entry])

  const showFavorites = useShowFavorites()
  const { isEnabled, mode, imageCopyKey } = usePersonalizationConfig()

  const showPersonalization = isEnabled && mode === 'modal'
  const HeaderWrapper = headerIsVisible ? StaticHeader : StickyHeader

  return (
    <div className="subheader" id={galleryHeaderId} ref={headerRef}>
      <HeaderWrapper>
        <GridContainer>
          <Row>
            <Column className="subheader-left" {...SIDEBAR_GRID_SPANS}>
              <SearchBox />
            </Column>
            <Column className="subheader-right" {...MAIN_GRID_SPANS}>
              {showFavorites && <FavoritesCTA userInteractionLocation="staticHeader" />}
              <FilterMenu shouldRenderSmallMobileIcon={showPersonalization} showColorFilterFirst={showPersonalization && imageCopyKey !== 'Photo'} />
              {showPersonalization && <PersonalizationModalOpenButton />}
            </Column>
          </Row>
        </GridContainer>
      </HeaderWrapper>
    </div>
  )
})

ActionHeader.displayName = 'SubHeader'
